import React from 'react';

const PlaceholderCard = () => {
    return <div className="content placeholder-card"></div>;
};

export default PlaceholderCard;
